import React from 'react';
import TooltipConstants from 'shared/constants/TooltipConstants';
import { Icon } from '@shoflo-rundown/polymer.legacy';

/* eslint-disable react/prop-types */

const DurationMuteIcon = (props) => {
  const { isSuppressed, onChange, withTooltip } = props;

  const icon = isSuppressed ? 'duration_muted' : 'duration_unmuted';

  const passProps = {
    name: icon,
    onClick: () => onChange(!isSuppressed),
  };

  if (withTooltip) {
    passProps.tip = TooltipConstants.CSDurationSuppression;
  }

  return (
    <div className="duration-picker-suppress-toggle">
      <Icon {...passProps} ours title="Suppress duration" />
    </div>
  );
};

export default DurationMuteIcon;
